module.exports = __webpack_public_path__ + "static/media/xav.eea36e8d.png";